<template>
  <div class="koc-block koc-purchase-product-select-block">
    <div class="koc-full">
      <div
        v-if="title"
        class="koc-tabs"
      >
        <span class="koc-button active">
          {{ title }}
        </span>
      </div>
      <div class="koc-options">
        <label
          v-for="option in options"
          :key="option.product.handle"
          class="koc-option koc-ripple"
          :class="{ active: option.product.handle === selected }"
        >
          <div class="koc-check">
            <input
              :id="option.product.handle"
              :checked="option.product.handle === selected"
              type="radio"
              name="option"
              :value="option.product.handle"
              @click="change(option.product.handle)"
            >
            <div class="koc-box" />
          </div>
          <h2>
            <b>{{ option.title }}</b>
            {{ option.description }}
            <template v-if="!option.cta">
              | {{ formatPrice(option.product.price) }}
            </template>
          </h2>
          <h4>
            <template v-if="option.duration">
              {{ formatPrice(option.product.price) }}/{{ option.duration }}
            </template>
            <span v-if="option.cta">
              |
              <b>{{ option.cta }}</b>
            </span>
          </h4>
          <p v-if="option.recurring">
            <i>{{ option.recurring }}</i>
          </p>
        </label>
      </div>
    </div>
  </div>
</template>

<script src="./product-select.js"></script>
<style lang="scss" scoped src="./product-select.scss"></style>